import React from 'react';

interface TrainerTopPanelProps {
    suggestions: React.ReactNode;
    prompt: React.ReactNode;
}

export function TrainerTopPanel({ suggestions, prompt }: TrainerTopPanelProps) {
    return (
        <>
            <div data-testid="trainer-suggestions-section">{suggestions}</div>
            <div data-testid="trainer-prompt-section">{prompt}</div>
        </>
    );
}
